import { render, staticRenderFns } from "./WasteMeasure.vue?vue&type=template&id=6680641a&scoped=true&"
import script from "./WasteMeasure.vue?vue&type=script&lang=js&"
export * from "./WasteMeasure.vue?vue&type=script&lang=js&"
import style0 from "./WasteMeasure.vue?vue&type=style&index=0&id=6680641a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6680641a",
  null
  
)

export default component.exports